import IncidentTypes from "../constants/IncidentTypes";
import { RouteConstants } from "../constants/RouteConstants";
import TrackingAccuracyReportStore from "./trackingAccuracyReportStore";

class MLBTrackingAccuracyReportStore extends TrackingAccuracyReportStore {
  fetchTrackingAccuracyReport(date) {
    return this.veracityApi.fetchTrackingMLBAccuracyReport(date);
  }

  cancelTrackingAccuracyReport() {
    return this.veracityApi.cancelTrackingMLBAccuracyReport();
  }

  isTrackingTabActive() {
    return this.routerStore.isMLBTrackingAccuracyReportTab;
  }

  updateNewIncidentMetadata(game) {
    return this.veracityStore.updateNewIncidentMetadata(
      IncidentTypes.MLB,
      game,
      this.get("date"),
      RouteConstants.BASE,
    );
  }
}

export default MLBTrackingAccuracyReportStore;
